import { useCurrentUser, isAuthenticated, getUserRole } from '@/lib/api/auth';

type UserRole = 'admin' | 'teacher' | 'student' | 'parent';

export function useAuth() {
  const { data: user, isLoading } = useCurrentUser();
  const userRole = getUserRole() as UserRole | null;
  
  return {
    user,
    isLoading,
    isAuthenticated: isAuthenticated(),
    userRole,
    isTeacher: userRole === 'teacher',
    isStudent: userRole === 'student',
    isAdmin: userRole === 'admin',
    isParent: userRole === 'parent',
  };
}
